<div class="flex flex-col">
    {{ params.service }}
    @if (params.orderId) {
        <div>
            Order:
            <button type="button" (click)="navigate()" class="text-primary-800">
                {{ params.orderId }}
            </button>
        </div>
    }
</div>
